import React from 'react';
import cx from 'classnames';
import { AccountType } from '@app/constants/constants';
import { isAgencyUserAccount } from '@app/utils/userUtils';

import styles from './PlanInclusions.module.scss';

export interface PlanInclusionsProps {
    constraintText: string;
    documentConstraintText?: string;
    accountType?: AccountType;
    showDisclaimer?: boolean;
    className?: string;
    includeTitle?: boolean;
}

const PlanInclusions: React.FC<PlanInclusionsProps> = ({
    constraintText,
    documentConstraintText,
    accountType,
    showDisclaimer = false,
    className,
    includeTitle = true
}) => {
    return (
        <div className={cx(styles.planInclusions, className)}>
            {includeTitle && <h4 className={styles.inclusionsTitle}>Monthly Inclusions:</h4>}
            <ul className={styles.inclusionsList}>
                <li className={styles.inclusionItem}>{constraintText}</li>
                {documentConstraintText && (
                    <li className={styles.inclusionItem}>
                        {documentConstraintText}
                        {showDisclaimer && <sup>1</sup>}
                    </li>
                )}
                {isAgencyUserAccount(accountType) && (
                    <li className={styles.inclusionItem}>
                        UNLIMITED <span className={styles.plainText}>everything else</span>
                    </li>
                )}
            </ul>
        </div>
    );
};

export default PlanInclusions;